import {ProfileSpecialist} from "./ProfileSpecialist"

export default ProfileSpecialist;
